// extracted by mini-css-extract-plugin
module.exports = {"menu":"W9CpJ95W","menuItem":"p1ac_vRf"};